import { ActivityCauserType } from '../../../types';

type ActivityCauserBadgeConfig = {
  label: string;
  colorPalette: string;
};

export const ACTIVITY_CAUSER_BADGE_CONFIG: Record<
  ActivityCauserType,
  ActivityCauserBadgeConfig
> = {
  [ActivityCauserType.Agent]: {
    label: 'Agent',
    colorPalette: 'blue',
  },
  [ActivityCauserType.Broker]: {
    label: 'Broker',
    colorPalette: 'yellow',
  },
  [ActivityCauserType.System]: {
    label: 'System',
    colorPalette: 'green',
  },
};

export const ACTIVITY_CAUSER_OPTIONS = Object.values(ActivityCauserType);
